import React from 'react';

import { Avatar, Container, Flex, Group, Text } from '@mantine/core';
import { useFullscreen } from '@mantine/hooks';
import { IconDotsVertical } from '@tabler/icons-react';
import Menu, { MenuItemProps } from 'components/Menu';
import { useAuth } from 'context/auth-context';
import useGym from 'hooks/gym/useGym';
import { Outlet } from 'react-router-dom';

const KioskLayout = (): JSX.Element => {
  const { toggle, fullscreen } = useFullscreen();
  const { logout, session } = useAuth();
  const { data } = useGym(session?.gym?.gymId);

  const handleLogout = (): void => {
    localStorage.removeItem('isKiosk');
    logout();
  };

  const items: MenuItemProps[] = [
    {
      title: fullscreen ? 'Exit Full Screen Mode' : 'Full Screen Mode',
      onClick: toggle,
    },
    {
      title: 'Log Out',
      onClick: handleLogout,
    },
  ];

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
    >
      <Container pt='xl' w='100%'>
        <Group position='apart' data-cy='gymNavigationPanel'>
          <Group align='center'>
            {data?.data && (
              <Avatar radius='xl' variant='outline' color='kiloBlue' src={data.data.profilePicture}>
                {data.data.title[0].toUpperCase()}
              </Avatar>
            )}
            <Flex direction='column' gap={0}>
              <Text weight={600} color='dark'>
                {data?.data.title}
              </Text>
              <Text color='dimmed'>{data?.data.email}</Text>
            </Flex>
          </Group>

          <Menu items={items} target={<IconDotsVertical cursor={'pointer'} />} position='bottom-end' />
        </Group>
      </Container>

      <Outlet />
    </div>
  );
};

export default KioskLayout;
